// extracted by mini-css-extract-plugin
module.exports = {"container":"Wallet_container__2fpCi","Wrapper":"Wallet_Wrapper__3SkCT","ChartWrapper":"Wallet_ChartWrapper__1tIr8","cardWrapper":"Wallet_cardWrapper__3R3nh"};